<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content class="mat-typography">
{{data.message}}
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>